import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase';
/*
  Generated class for the FirebaseProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FirebaseProvider {

 list:any;

  constructor(public http: Http, public afd: AngularFireDatabase) {
  }

fetchItems() {
  return this.afd.list('/nhf');
}

	fetchDrugs() {
		// this.list = [{"drugname": "", "info": "", "pic": "", "url": ""}];
		let items$;
		this.afd.list('/Drugs/').subscribe(
			(data) => {
				items$ = data,
				this.pushList(items$) 
			}
		)
	}
 
	pushList(liss) {
		this.list = liss;
		//  console.log(this.list);
	}
	//getDrugs() {
	//    let list = this.fetchDrugs();
	//    return list;
//  }

	addDrug(drug) {
		this.afd.list('/Drugs/').push(drug);
	}
 
	updateDrug(drug, key) {
		this.afd.object('Drugs/'+key).update(drug);
	}
	
	removeDrug(id) {
		this.afd.list('/Drugs/').remove(id);
	}

	nhfDrug(drug) {
		this.afd.list('/Nhf/').push(drug);
	}

	removeNhf(id) {
		this.afd.list('/Nhf/').remove(id);
	}

   userLogin(email: string, password: string): firebase.Promise<any> {
    return firebase.auth().signInWithEmailAndPassword(email, password);
   //   return this.afd.app.auth().signInWithEmailAndPassword(email, password);
  }
	getList() {
		return this.afd.object('/Nhf')
	}

	goList() {
		return this.afd.object('/Drugs')
	}
	filterItems(searchTerm){
		return  this.goList()
        .subscribe(
         (data) => this.list = data, //.filter((item) => {
   //        console.log(data)
     //      return item.drugname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      //   } ),
        
         (err) => {console.log(err); return [{"drugname": "", "info": "", "pic": "", "url": ""}]}
        )
    }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/firebase.ts